import { useEffect, useState } from "react";
import { IdentityClient } from "../../../../types/auto/types";
import { Configuration } from "../../../Constants";
import { getCookie } from "../../../utils/cookie";
import { FetchOverride } from "../../../utils/Request";
import TimeoutAlert from "./TimeoutAlert";

export const TimeoutComponent = (): JSX.Element => {
  const [timeoutSwitch, setTimeoutSwitch] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (
        parseInt(getCookie("TrueColours_Expiration")) -
          Math.floor(Date.now() / 1000) <=
        60
      ) {
        setOpenAlert(true);
      }
      if (getCookie("TrueColours_Expiration").length === 0) {
        window.location.href = new IdentityClient(
          Configuration.SERVER_ROOT,
          FetchOverride
        ).getLogoutURL();
      }
      setTimeoutSwitch(!timeoutSwitch);
    }, Configuration.TIMEOUTCHECK);
    return () => clearTimeout(handler);
  }, [timeoutSwitch]);
  return (
    <>
      <TimeoutAlert open={openAlert} setOpen={setOpenAlert} />
    </>
  );
};

export default TimeoutComponent;
